import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, inject } from "vue";
import { useDeviceStore } from "@/stores/deviceStore";
import { useSurveyStore } from "@/stores/surveyStore";
import InlineSvg from "vue-inline-svg";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import BaseSelect from "@/components/shared/inputs/base/BaseSelect.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import BaseTextarea from "@/components/shared/inputs/base/BaseTextarea.vue";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import Modal from "@/components/shared/modal/base/Modal.vue";
import Page from "@/components/shared/Page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceEvaluation',
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const deviceStore = useDeviceStore();
const surveyStore = useSurveyStore();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const isShowingKeyboard = computed(() => deviceStore.isShowingKeyboard);
watch(isShowingKeyboard, (isShowingKeyboard) => {
  if (isShowingKeyboard) {
    setTextAreaScroll();
    return;
  }
});

const moodIconList = [
  {
    src: require("@/assets/icons/moods/mood-bad.svg"),
    score: 1,
    detail: "별로에요",
  },
  {
    src: require("@/assets/icons/moods/mood-soso.svg"),
    score: 2,
    detail: "그저그래요",
  },
  {
    src: require("@/assets/icons/moods/mood-normal.svg"),
    score: 3,
    detail: "보통이에요",
  },
  {
    src: require("@/assets/icons/moods/mood-good.svg"),
    score: 4,
    detail: "좋아요",
  },
  {
    src: require("@/assets/icons/moods/mood-nice.svg"),
    score: 5,
    detail: "최고에요",
  },
];

/** 서비스 평가 불가 팝업 처리 */
const showModalNotEvaluatingService = ref(false);
const toggleShowModalNotEvaluatingService = (show: boolean) => {
  showModalNotEvaluatingService.value = show;
};
const onCloseServiceEvaluation = () => {
  emit("onClickClose");
};

const lineSurvey = computed(() => surveyStore.lineSurvey);
const userAnswers = ref<Map<number, Map<string, string | string[]>>>(new Map());
const selectedLineId = ref("");
const selectedScore = ref(0);
const selectedReview = ref<string[]>([]);
// const opinion = ref("");

const onChangeSelectLine = (uid: string) => {
  selectedLineId.value = uid;
};

const onClickMoodIcon = (uid: string, order: number) => {
  selectedScore.value = parseInt(uid);
  const map = new Map<string, string>();
  map.set("selected", uid);
  userAnswers.value.set(order - 1, map);
};

const isSelectedReview = (review: string) => {
  return selectedReview.value.includes(review);
};
const onClickReview = (review: string, order: number) => {
  if (isSelectedReview(review)) {
    selectedReview.value = selectedReview.value.filter(
      (reviewItem: string) => reviewItem !== review
    );
    return;
  }
  selectedReview.value.push(review);
  const map = new Map<string, string[]>();
  map.set("selected", selectedReview.value);
  userAnswers.value.set(order - 1, map);
};

const onInputTextarea = (opinion: string, order: number) => {
  const map = new Map<string, string>();
  map.set("inputValue", opinion);
  userAnswers.value.set(order - 1, map);
};

const getTextAreaLength = (questionOrder: number) => {
  if (!userAnswers.value.get(questionOrder - 1)) {
    return 0;
  }
  return userAnswers.value.get(questionOrder - 1)!.get("inputValue")!.length;
};

const isEvaluable = () => {
  return (
    selectedLineId.value && selectedScore.value && selectedReview.value.length
  );
};
const onClickEvaluate = async () => {
  userAnswers.value = new Map([...userAnswers.value.entries()].sort());
  const sendSurveyResult = await surveyStore.sendSurveyResult(
    lineSurvey.value!.id,
    userAnswers.value,
    selectedLineId.value
  );
  if (!sendSurveyResult.isSuccess) {
    showErrorModal(
      "서비스평가 제출 오류",
      sendSurveyResult.errorMessage,
      sendSurveyResult.resultCode,
      sendSurveyResult.errorTime
    );
    return;
  }
  showToastMessage("서비스 평가 완료되었습니다.", 3000, 350);
  onCloseServiceEvaluation();
};

const textArea = ref();
const serviceEvaluation = ref();
const setTextAreaScroll = () => {
  const textAreaY = textArea.value?.getBoundingClientRect().top || 0;
  const serviceEvaluationY =
    serviceEvaluation.value.getBoundingClientRect().top;
  const offset = textAreaY - serviceEvaluationY;
  serviceEvaluation.value.scrollTo({
    top:
      offset > 0
        ? offset + serviceEvaluation.value.scrollTop
        : serviceEvaluation.value.scrolltop,
    behavior: "smooth",
  });
};

const __returned__ = { emit, deviceStore, surveyStore, showErrorModal, showToastMessage, isShowingKeyboard, moodIconList, showModalNotEvaluatingService, toggleShowModalNotEvaluatingService, onCloseServiceEvaluation, lineSurvey, userAnswers, selectedLineId, selectedScore, selectedReview, onChangeSelectLine, onClickMoodIcon, isSelectedReview, onClickReview, onInputTextarea, getTextAreaLength, isEvaluable, onClickEvaluate, textArea, serviceEvaluation, setTextAreaScroll, get InlineSvg() { return InlineSvg }, NavigationBar, BaseSelect, FooterButton, BaseTextarea, Modal, Page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})